import { useTranslations } from 'next-intl';

import { Styles, css } from '@flipster/styled-system/css';

export interface HaveNoPositionsProps {
  css?: Styles;
  positionType: 'open' | 'pending';
}
export const HaveNoPositions = ({ css: cssProps, positionType }: HaveNoPositionsProps) => {
  const t = useTranslations();

  return (
    <div
      className={css({
        px: 16,
        py: { base: 8, tablet: 20 },
        bg: 'background.default.level-1',
        rounded: 8,
        color: 'content.default.level-5',
        ...cssProps,
      })}
    >
      {positionType === 'open'
        ? t('Assets.r250401.All_effective_orders_and_contracts_you_possess_show_here')
        : t('Trade.r251104.When_place_limit_trigger_order_still_awaiting_show')}
    </div>
  );
};
